import { useGlobalStore } from '../../../Common/store';
import bindActions from '../../../Common/actions';
import tokenReducer from '../../store/tokenFlow';

const { actions } = tokenReducer;

/**
 * use Token flow Custom Hook
 */
const useTokenFlow: any = () => {
	const { state , dispatch } = useGlobalStore();

	// List of Props
	const { tokenFlow } = state;

	// List of Actions
	const {
		handleStartTokenFlow  
	} = actions;

	// Bind Actions
	const tokenActions = bindActions({
		handleStartTokenFlow
	}, dispatch);

	return { tokenFlow, ...tokenActions };
}

export default useTokenFlow;
